export const FONT_STACK =
  "'PT Sans', 'Roboto', 'Helvetica', 'Arial',  sans-serif";
export const BOLD_FONT = 700;
export const NORMAL_FONT = 400;
